import React, { Component } from 'react';
import ComponentCustom from '../custom/CompentCustom';

class PageCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="mb16" id="custom">
        <ComponentCustom {...this.props} incuUuid={this.props.params.uuid} />
      </div>
    );
  }
}

export default PageCustom;



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageCustom.js